import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { COMPANY } from "../content";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "inexponens_admin_token";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) {
      toast.error("Veuillez saisir votre identifiant et votre mot de passe.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { username: username.trim(), password });
      localStorage.setItem(TOKEN_KEY, res.data.token);
      toast.success(`Bienvenue, ${res.data.username} !`);
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Connexion impossible. Réessayez.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#141d43] flex items-center justify-center px-5 pt-20" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-2xl p-8 md:p-10">
          <div className="text-center mb-8">
            <img src={COMPANY.logo} alt="INEXPONENS" className="h-14 w-auto object-contain mx-auto mb-4" />
            <h1 className="text-2xl font-semibold text-[#1b2653]">Espace Administration</h1>
            <p className="text-slate-500 text-sm font-light mt-2">
              Accès réservé au cabinet {COMPANY.name}
            </p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label htmlFor="admin-username" className="text-[#1b2653] text-sm">Identifiant</Label>
              <div className="relative mt-2">
                <User size={17} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
                <Input
                  id="admin-username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Votre identifiant"
                  className="pl-10 h-11"
                  data-testid="admin-input-username"
                />
              </div>
            </div>
            <div>
              <Label htmlFor="admin-password" className="text-[#1b2653] text-sm">Mot de passe</Label>
              <div className="relative mt-2">
                <Lock size={17} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
                <Input
                  id="admin-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Votre mot de passe"
                  className="pl-10 h-11"
                  data-testid="admin-input-password"
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-full py-3.5 bg-[#1b2653] text-white text-[13px] font-semibold uppercase tracking-[0.18em] hover:bg-[#2f6fd8] transition-colors duration-300 disabled:opacity-60"
              data-testid="admin-login-btn"
            >
              {loading ? "Connexion..." : "Se connecter"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
